import React from "react";

import "./TextInputLengthInfo.scss";

interface Props {
  /**
   * String to measure the length of.
   */
  value: string;
  
  /**
   * Minium length of `value`. Label highlights in red if it's shorter.
   */
  minLength?: number;

  /**
   * Maximum length of `value`. Label highlights in red if it's longer.
   */
  maxLength?: number;
}

/**
 * Indicator for the length of a string. Useful with a text input component.
 * 
 * @status review
 * - if neither `maxLength` or `minLength` are set, the component renders nothing.
 */
export const TextInputLengthInfo = ({ value, maxLength, minLength }: Props) => {

  const isOverMax = maxLength && value != null && value.length > maxLength;
  const isUnderMin = minLength && (value == null || value.length < minLength);
  const numUnderMax = maxLength ? (value != null ? maxLength - value.length : maxLength) : 0;
  const numUnderMin = minLength ? (value != null ? minLength - value.length : minLength) : 0;

  return (
    <div className="text-input-length-info">
      <span className={"description-meta " + (isOverMax || isUnderMin ? "status-warning" : "status-ok")}>

        {(maxLength && !isOverMax && !isUnderMin) &&
          <span className="remainingCharacters">{numUnderMax} character{numUnderMax === 1 ? "" : "s"} remaining</span>
        }

        {isOverMax &&
          <span className="length-warning max-length">
            Please only use {maxLength} characters ({-numUnderMax} over the limit)
          </span>
        }

        {isUnderMin &&
          <span className="length-warning min-length">
            Please enter at least {minLength} characters ({numUnderMin} more required)
          </span>
        }
      </span>
    </div>
  );
};
